<template>
  <v-flex class="agent-account">
    <v-card>
      <avatar-block-component
        :profile="agentData"
      />
      <v-divider />
      <personal-info-block-component
        :profile="agentData"
      />
      <v-divider />
      <email-block-component
        :profile="agentData"
      />

      <v-divider />
      <password-block-component
        :profile="agentData"
      />
      <!-- <v-divider /> -->
      <!-- <agent-broker-info
        :profile="agentData"
      /> -->
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import colors from '../../scss/_colors.scss'
import PersonalInfoBlockComponent from '../common/PersonalInfoBlockComponent'
// import AgentBrokerInfo from '../agent/AgentBrokerInfo'
import PasswordBlockComponent from '../common/PasswordBlockComponent'
import AvatarBlockComponent from '../common/AvatarBlockComponent'
import EmailBlockComponent from '../common/EmailBlockComponent'
export default {
  components: { PersonalInfoBlockComponent, PasswordBlockComponent, AvatarBlockComponent, EmailBlockComponent },
  props: {
    profile: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      agentPassword: '',
      colors
    }
  },
  computed: {
    ...mapState('common', ['isMobile']),
    ...mapState('agent', ['agentData'])
  },
  methods: {
    ...mapMutations('agent', {
      setAgentMedia: 'SET_AGENT_MEDIA',
      setAgentData: 'SET_AGENT_DATA'
    })
  }
}
</script>
<style lang="sass">
.agent-account
  display: flex
  @media only screen and (max-width: 450px)
    height: 100vh
.agent-account .v-card
  width: 100%
  height: 100%
  flex: 1 auto
.card-title
  font-weight: 450 !important
  font-size: 1.4rem !important
  padding: 16px 16px 0 !important
  display: flex
  justify-content: space-between
.card-title span
  color: $hwayzBrandGold !important
  font-size: 1.4rem
  cursor: pointer
.card-title span:hover
  color: $hwayzBrandBlue !important
.v-divider
  margin: 0 20px
</style>
